import { lazy, Suspense } from 'react';
import './App.scss';
import { usePlatform } from './shared/hooks';
import { AppProvider } from './shared/provider/AppProvider';
import { ErrorBoundary } from './shared/components/ErrorBoundary/ErrorBoundary';
import { StyledProvider } from '@abtasty/design-system';

const FsApp = lazy(() => import('./flagship/App'));
const TagApp = lazy(() => import('./tag/App'));
const PlatformChoice = lazy(() => import('./shared/PlatformChoice/PlatformChoice'));

const componentMap = {
  BOTH: PlatformChoice,
  FS: FsApp,
  TAG: TagApp,
};

const Wrapper = () => {
  const platformType = usePlatform();

  const CurrentComponent = componentMap[platformType];
  return (
    <Suspense fallback={null}>
      <ErrorBoundary>
        <StyledProvider>
          <CurrentComponent />
        </StyledProvider>
      </ErrorBoundary>
    </Suspense>
  );
};

export const App = () => {
  return (
    <ErrorBoundary>
      <AppProvider>
        <Wrapper />
      </AppProvider>
    </ErrorBoundary>
  );
};
